import React from 'react';

import { Box } from '@material-ui/core';
import { FaPlusCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import { HeaderCardProps } from '.';
import { PaperContainer } from './styles';

import { IconContext } from 'components/IconContext';
// import { TypographyCN } from 'components/TypographyCN';
import { useStyledTheme } from 'styles';
import 'styled-components/macro';
import { TypographyCN } from 'components/atoms/Typograph';

export function HeaderCard({ icon, subtitle, title, registerUrl, disablePlus, value = 0, color }: HeaderCardProps) {
  const theme = useStyledTheme();

  return (
    <PaperContainer>
      <Box display="flex" justifyContent="space-between">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          bgcolor="#F4F4F4"
          height="90px"
          width="90px"
          borderRadius="50%"
        >
          {<IconContext size="3.5rem" icon={icon} color={color} />}
        </Box>
        {disablePlus || (
          <Link to={registerUrl || ''} css="height: 50%;">
            <IconContext size="2rem" icon={<FaPlusCircle />} color="#24C361" />
          </Link>
        )}
      </Box>
      <Box display="flex" flexDirection="column" alignItems="flex-end" alignSelf="flex-end">
        <TypographyCN fontType="Proxima Nova" size="big-title" weight="big" text={value.toString()} />
        <TypographyCN size="mob-simple" weight="big" color="primary" text={title} />
        <TypographyCN size="mob-simple" weight="big" color="primary" text={subtitle} />
      </Box>
    </PaperContainer>
  );
}

export function HeaderCardConfig({ icon, subtitle, title, onClick, disablePlus, value = 0, color }: HeaderCardProps) {
  const theme = useStyledTheme();

  return (
    <PaperContainer>
      <Box display="flex" justifyContent="space-between">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          bgcolor="#F4F4F4"
          height="90px"
          width="90px"
          borderRadius="50%"
        >
          {<IconContext size="3.5rem" icon={icon} color={color} />}
        </Box>
        {disablePlus || (
          <button onClick={onClick} type="button" css="height: 50%; background: none; border: none; cursor: pointer;">
            <IconContext size="2rem" icon={<FaPlusCircle />} color="#24C361" />
          </button>
        )}
      </Box>
      <Box display="flex" flexDirection="column" alignItems="flex-end" alignSelf="flex-end">
        <TypographyCN fontType="Proxima Nova" size="desk-variation-two" weight="medium" text={value.toString()} />
        <TypographyCN size="desk-simple" color="primary" text={title} />
        <TypographyCN size="desk-simple" color="primary" text={subtitle} />
      </Box>
    </PaperContainer>
  );
}
